import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'unshift' ).path;
